module.exports = __webpack_public_path__ + "static/media/homilia-370-aparicion-virgen-coromoto-small.859f9dc3.jpg";